function reloadCurrentPage() {
  document.location.reload();
}

export default reloadCurrentPage;
